import PlayIcon from '../../assets/icons/components/PlayIcon'
import PersonIcon from '../../assets/icons/components/PersonIcon'
import LetterIcon from '../../assets/icons/components/LetterIcon'
import { Text } from '@fable/components'
import { css, cx } from '@fable/theme'

export const renderPostTag = (tag) => {
  let icon

  switch (tag) {
    case 'Padma Letter':
      icon = <LetterIcon />
      break
    case 'Video':
      icon = <PlayIcon />
      break
    default:
      icon = <LetterIcon />
      break
  }

  if (tag === 'Simple Post') tag = 'Post'

  return (
    <Text
      className={cx(
        css`
          text-transform: uppercase;
          display: flex;
          align-items: center;
        `,
        'blog-post-tag'
      )}
      type="label"
      sizing="L"
    >
      {icon}
      &nbsp;
      <b>{tag}</b>
    </Text>
  )
}

export const renderParticipantsTag = (participants) => {
  const icon = <PersonIcon />
  const tag = participants.length > 1 ? 'Panel' : 'Speaker'

  return (
    <Text
      className={cx(
        css`
          text-transform: uppercase;
          display: flex;
          align-items: center;
        `,
        'participants-tag tag'
      )}
      type="label"
      sizing="L"
    >
      {icon}
      About the {tag}
    </Text>
  )
}

// get ticket price
export function getTicketPrice(ticketPrice) {
  if (ticketPrice !== 0) return `$${ticketPrice}`

  return 'Free'
}

export const getEventCalendarLinks = (event) => {
  const links = []

  if (event.appleCalendarLink) {
    links.push({ provider: 'apple', url: event.appleCalendarLink })
  }

  if (event.googleCalendarLink) {
    links.push({ provider: 'google', url: event.googleCalendarLink })
  }

  if (event.outlookCalendarLink) {
    links.push({ provider: 'outlook', url: event.outlookCalendarLink })
  }

  return links
}
